import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import MDTypography from 'components/MDTypography';

function InfoRow({ label, value }) {
  return (
    <Grid container spacing={2} alignItems="baseline">
      <Grid item xs={5} display="flex" alignItems="center">
        <MDTypography variant="caption" color="text" fontWeight="bold">
          {label}
        </MDTypography>
      </Grid>
      <Grid item xs={7} display="flex" alignItems="center">
        <MDTypography variant="body2" color="text" sx={{ whiteSpace: 'pre-wrap' }}>
          {value || '-'}
        </MDTypography>
      </Grid>
    </Grid>
  );
}

InfoRow.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default InfoRow;
